var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapefooterIcons2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.103,
    height: 59.091,
    viewBox: "0 0 72.103 59.091",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.75968 1.17404e-06C3.02777 1.17404e-06 0 3.30851 0 7.38644C0 9.7101 0.999869 11.8953 2.70387 13.2956C2.70387 13.2956 33.3478 38.4095 33.3478 38.4095C34.9532 39.7175 37.1501 39.7175 38.7555 38.4095C38.7555 38.4095 69.3994 13.2956 69.3994 13.2956C71.1034 11.8953 72.1033 9.7101 72.1033 7.38644C72.1033 3.30851 69.0755 0 65.3436 0C65.3436 0 6.75968 1.17404e-06 6.75968 1.17404e-06C6.75968 1.17404e-06 6.75968 1.17404e-06 6.75968 1.17404e-06ZM0 17.2348C0 17.2348 0 49.2427 0 49.2427C0 54.6748 4.04173 59.0913 9.01291 59.0913C9.01291 59.0913 63.0903 59.0913 63.0903 59.0913C68.0615 59.0913 72.1033 54.6748 72.1033 49.2427C72.1033 49.2427 72.1033 17.2348 72.1033 17.2348C72.1033 17.2348 41.4594 42.3487 41.4594 42.3487C38.2485 44.9801 33.8547 44.9801 30.6439 42.3487C30.6439 42.3487 0 17.2348 0 17.2348L0 17.2348Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapefooterIcons2);
export default __webpack_public_path__ + "static/media/ShapefooterIcons 2.95e7794f56e18c2232563218b34c0f61.svg";
export { ForwardRef as ReactComponent };